<template>
  <div class="page withdraw-index">
    <navigation type="second-level" :sticky="true" @click="detention" :customClickEvent="true">
      我要提现
    </navigation>
    <!-- 提现金额调整 -->
    <div class="withdraw-money card-panel">
      <temporary-limit class="temporary-limit" :temporaryLimit="bizAdjustAmount" :maxLimit="limitMaxCanLoanAmount" v-if="bizAdjustAmount && limitMaxCanLoanAmount"></temporary-limit>
      <div class="title">当前可用额度（元）{{ productRemaindLimit | currency }}</div>

      <div class="money-operate">
        <div class="money" @click="openKeyboard">
          {{ form.applyAmt | amount }}
        </div>
        <div class="max-withdraw" @click="maxWithdraw">最大提现</div>
      </div>

      <div class="money-range clearfix">
        <div class="min-money">
          最低(元) {{ productMinLimit | amount }}
        </div>
        <div class="max-money">
          最高(元) <em>{{ maxAmt | amount }}</em>
        </div>
      </div>
    </div>

    <!-- 提现参数 -->
    <form class="form card-panel" ref="form">
      <div class="form-item underline-un-focus">
        <nd-choose
          label="怎么花"
          :valueKey="['key', 'description']"
          :data="dictionary.loanPurpose"
          v-model="form.purpose"
        >
        </nd-choose>
      </div>

      <div class="form-item underline-un-focus">
        <nd-choose
          label="分几期"
          :data="termList"
          :placeholder="placeholder"
          v-model="form.applyTerm"
          :beforeClick="beforeSelectTerm"
        >
        </nd-choose>
      </div>

    </form>
    <div v-if="svipLimitTips" class="svip-banner">
      <img src="./image/Img_kefu@2x.png"/>
      <p class="svip-banner-content"><span>{{svipLimitTips}}</span><span class="red" @click="jumpVip('withDraw')">立即前往 ></span></p>
    </div>
    <div class="tips" v-else-if="!canLoanApply">
      {{ canotLoanReason }}
    </div>
    <div class="tips" v-else-if="canLoanApply && canLoanApplyMessage && !isExternalChannel">
      {{ canLoanApplyMessage }}
    </div>
    <withdraw-mao :amount="form.applyAmt" status="7" type="withdraw" :point="10501"/>
    <section class="bottom">
      <div class="animate-tag" v-if="subscriptData && !isRosewalletChannel">
        <span>99.6%</span>高通过率提现，还剩<span>{{ subscriptData }}</span>个名额
      </div>
      <nd-button class="confirm" @click="next" :disabled="isDisabled">{{ canLoanApply ? '下一步：预览提现详情' : '暂不可提现'}}</nd-button>
      <section class="read-protocol">
        <span>综合年化利率以实际每笔订单放款审核为准</span>
      </section>
    </section>


    <!--自定义键盘-->
    <nd-keyboard
      ref="keyboard"
      :stepSize="lendingAmountStep"
      :start-money="startMoney"
      :visible="keyboardVisible"
      @changeResult="getKeyboardInput"
      @step="stepHandler"
    ></nd-keyboard>
   
    <nd-dialog
      v-model="tipsVisible"
      class="tips-dialog"
      :footer="false"
      :closeBtn="true"
      @close="tipsVisible=false"
    >
      <div class="tips-content">
        <div class="header">
          温馨提示
        </div>
        <p class="body">
          尊敬的用户，我们发现您的最高可提现金额<span
            class="highlight"
          >{{ productMaxLimit | amount }}元</span>
        </p>
        <p class="body">
          您提现成功后，需要结清借款后才可以再次发起提现哦，请您妥善评估提现金额以备不时之需。
        </p>
        <nd-button class="footer" @click="confirm">
          立即提现{{ productMaxLimit | amount }}元
        </nd-button>
        <p class="cancel" @click="cancel">已知悉，暂不需要这么多金额</p>
      </div>
    </nd-dialog>

    <!-- 挽留弹窗 -->
    <nd-dialog v-model="detentionVisible" :footer="false" class="detention-dialog">
      <div class="detention-dialog-content">
        <div class="detention-title">
          <span>立即</span>提现，<span>秒速</span>审批，<span>即刻</span>到账
        </div>

        <ul class="giveup">
          <li  @click="detensionForChangeAmount">
            我想修改提现金额
          </li>
          <li  @click="giveUp(2)">
            我不想拿钱了
          </li>
        </ul>

        <button class="continue" @click="continueApply">继续提现</button>
      </div>
    </nd-dialog>

    <!-- 活动弹窗 -->
    <nd-dialog
      v-model="activityVisible"
      :footer="false"
      closeBtn
      class="activity-dialog"
    >
      <div class="activity-content">
        <template v-if="currentActivity.couponDetailType === 'A'">
          <div class="slogan">
            <img src="../authentication/images/img_20yuan@2x.png" alt="">
          </div>

          <p class="text">
            立即申请借款，现金还是红包，总有一笔会到账！
          </p>

          <p>
            活动期间<em>借款通过率为平时2倍</em>!
          </p>

          <div class="description">
            <div class="desc-image"></div>

            <p>
              提现未通过,即刻赔付现金红包！
              <em>更有幸运儿可获100元</em>
            </p>
          </div>

          <nd-button class="continue-btn" @click="activityContinue">继续提现</nd-button>

          <div class="giveup-btn" @click="activityGiveUp">给钱也不要</div>
        </template>
        <template v-else>
          <div class="slogan">
            <img src="../authentication/images/img_100yuan@2x.png" alt="">
          </div>

          <p class="text">
            立即申请借款，现金还是红包，总有一笔会到账！
          </p>

          <p>
            活动期间<em>借款通过率为平时2倍</em>!
          </p>

          <div class="description">
            <div class="desc-image"></div>

            <p>
              授信未通过,即刻赔付现金红包！
              <em>最高赔100元</em>
            </p>
          </div>

          <nd-button class="continue-btn" @click="activityContinue">继续提现</nd-button>

          <div class="giveup-btn" @click="activityGiveUp">给钱也不要</div>
        </template>
      </div>
    </nd-dialog>

    <!-- 活动弹窗 -->
    <nd-dialog
      v-model="activityTempleVisible"
      :footer="false"
      closeBtn
      class="activity-dialog"
    >
      <div class="activity-template-content" :style="{ 'background-image': `url(${ currentActivity.icon })` }">
        <div class="button-group">
          <nd-button class="continue-btn" @click="activityContinue">继续提现</nd-button>
          <div class="giveup-btn" @click="activityGiveUp">放弃免息奖励</div>
        </div>
      </div>
    </nd-dialog>

    <!-- 活动弹窗 -->
    <nd-dialog
      v-model="showPricingPopup"
      :footer="false"
      closeBtn
      class="pricingPopup-dialog"
    >
      <div class="pricingPopup">
        <div class="pricingPopup-tip">温馨提示</div>
        <p>尊敬的用户，因您资质良好，本次提现可享受综合年化利率(单利计息)下降至24.00%</p>
        <p class="pricingPopup-content">请您妥善评估所需金额，进行提现操作以备不时之需。</p>
        <nd-button class="pricingPopup-button" @click="jumpPreview">立即提现</nd-button>
      </div>
    </nd-dialog>

    <nd-dialog
      v-model="svipDialog"
      :footer="false"
      closeBtn
      isShowBg
      class="dialog"
    >
      <svip-dialog @close="svipDialog=false" @judgeOrder="judgeOrder" :svipData="svipData" @next="next"/>
    </nd-dialog>

    <nd-dialog
      v-model="payDialog"
      :footer="false"
      closeBtn
      class="activity-dialog"
    >
      <pay-dialog @close="payDialog=false" @jumpMiddle="jumpMiddle" :payStatusInfo="payStatusInfo"/>
    </nd-dialog>

    <withDrawActionSheet
      v-model="passCardBuyGuideActionSheetVisible"
      :isPreview="false"
      @onTopAction="backHome"
    />
    <detention-dialog
      v-model="oldGuestDetentionVisible"
      @onGiveUp="backHome"
    />
    <reconfirm-dialog
      v-model="reconfirmDialogVisible"
      :data="reconfirmDialogData"
      @onGiveUp="backHome"
    />
    <!-- 返回首页 -->
    <back-home-drag y="13" v-if="showBackHomeDrag"></back-home-drag>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { isEmptyObject, getKey, setKey, removeKey } from '../../assets/utils'
import svipDialog from './components/svipDialog.vue'
import payDialog from '../../components/withdraw-mao/payDialog.vue'
import WithdrawMao from '@/components/withdraw-mao/index.vue'
import withDrawActionSheet from './components/withdraw-action-sheet.vue'
import qs from 'qs'
let throttleLastTimer = 0
let throttleGutter = 1000

export default {
  name: 'withdraw-index',

  description: '我要提现',

  customReadyNotify: true,
  components: {
    svipDialog,
    payDialog,
    WithdrawMao,
    withDrawActionSheet,
    'detention-dialog': () => import('./components/detention-dialog.vue'),
    'reconfirm-dialog': () => import('./components/reconfirm-dialog.vue'),
    'temporary-limit': () => import('./components/temporary-limit.vue')
  },
  data () {
    return {
      showBackHomeDrag: false,
      showPricingPopup: false, // 是否弹出IRR24利率弹窗
      detentionVisible: false,
      needShowOldGuestDetentionPop: false, // 是否需要展示老客挽留弹窗
      oldGuestDetentionVisible: false, // 老客挽留弹窗
      reconfirmDialogVisible: false, // 二次确认弹窗，弹出条件 - 1. 点击了金额输入框 2. 未点击下一步 3. 接口返回了对应的数据
      reconfirmDialogData: {}, // 二次确认弹窗数据
      activityVisible: false,
      form: {
        applyAmt: '',
        applyTerm: '',
        purpose: '',
        bankCardNo: ''
      },
      productRemaindLimit: 0,
      productMaxLimit: 5000,
      productMinLimit: 5000,
      lendingAmountStep: 500,
      productSubList: [],
      amtProductList: [], // 通过金额查询子产品
      fundCode: '',
      // 陀螺仪旋转发生次数
      deviceorientationEventOccurCount: 0,
      keyboardVisible: false,
      showNotice: false,
      stepCount: 0,
      tipsVisible: false,
      canLoanApply: true,
      canotLoanReason: '',
      canLoanCode: '',
      popupList: [],
      activityTempleVisible: false,
      currentActivity: {},
      canLoanApplyMessage: '',
      isExternalChannel: ['API-XHQB'].includes(getKey('channel')),
      isRosewalletChannel: ['API-rosewallet'].includes(getKey('channel')),
      svipLimitTips: '', // 温馨提示
      couponSerialNos: this.$route.query.couponSerialNos, // 券包运营活动跳转过来的券号
      couponType: this.$route.query.couponType, // 券包运营活动跳转过来的类型
      svipDialog: false,
      payDialog: false,
      svipData: {}, // svip弹窗数据
      payStatusInfo: {}, // 过期返回的数据
      passCardBuyGuideActionSheetVisible: false,
      source: this.$route.query.from,
      subscriptData: 0,
      bizAdjustAmount: 0, // 业务侧调额
      limitMaxCanLoanAmount: 0 // 限时最高可提额度
    }
  },

  computed: {  
    ...mapState('withdraw', {
      loanParameter: (state) => state.loanParameter,
      withdrawForm: (state) => state.withdrawForm,
      fundData: (state) => state.fundData
    }),
    ...mapState('user', {
      creditStatus: (state) => state.quotaInfo.creditStatus
    }),
    ...mapState({
      dictionary: state => state.dictionary,
      caseList: state => state.caseList
    }),
    maxAmt () {
      let _amt = 0
      if (this.limitMaxCanLoanAmount) {
        _amt = this.productMaxLimit > this.limitMaxCanLoanAmount ? this.limitMaxCanLoanAmount : this.productMaxLimit
      } else {
        _amt = this.productMaxLimit
      }
      return _amt
    },
    placeholder () {
      return this.termList.length > 0 ? '请选择' : '暂无支持分期'
    },
    termList () {
      if (!this.productSubList || this.productSubList.length === 0) {
        return []
      }
      var cycles = this.amtProductList.map((item) => {
        return {
          name: item + '个月',
          value: item
        }
      })
      return cycles
    },
    isDisabled () {
      return !(
        this.form.applyAmt &&
        this.form.applyTerm &&
        this.form.purpose &&
        this.canLoanApply
      )
    },
    // 键盘起始值
    startMoney () {
      return Number(this.form.applyAmt)
    },
    isFromPassCard () {
      return this.$route.query.from === 'passcard'
    }
  },
  watch: {
    async 'form.applyAmt' (value) {
      if (value <= 0) {
        return
      }
      this.getAmtProduct(value)
    }
  },
  async created () {
    this.setNeedsShowReconfirmDialog(null)
    await this.getLimitX({ loanPlatform: 'TMD' })
    const isPasscard = await this.checkIsPasscard()
    if (isPasscard) {
      return
    }
    // 初始化表单
    this.form = this.withdrawForm
    // 如果state中数据为空，则尝试在本地缓存中获取
    if (isEmptyObject(this.form)) {
      this.form = this.$storage.get('withdrawForm')
    }
    try {
      const { purchaseSuccessSVIP, couponSerialNos, couponType } = this.$route.query || {}
      let bool = false // 是否需要调用后面的接口
      if (purchaseSuccessSVIP === 'giveUp') {
        bool = false
        this.memberInfoX()
      } else {
        bool = await this.memberInfoX()
      }
      if (bool) {
        let obj = couponSerialNos ? { couponSerialNos, couponType } : {}
        this.$router.replace({ path: '/withdraw/ssvip', query: { purchaseSVIP: 'withSvip', ...obj } })
      } else {
        await Promise.all([
          this.fetchDictionaryX(),
          this.loanAmountPageX(),
          this.getCaseListX({ loanPlatform: 'TMD', step: 'LOAN' }),
          this.getSubscript()
        ])
        await this.canLoan() // 当前是否可借款
        this.$bus.$emit('ready')
        // 跳转到其它界面传参 unsatisfied:贷后还款表现不满足放款 time当前时间系统暂不支持提现 failed身份信息验证失败，暂不支持提现 expired身份证信息已到期，需重新上传 aboutToExpire您的身份证信息30天内即将过期
        let status = this.judge(this.canLoanCode)
        // 状态为3的时候不传入count
        let count = status !== 'expired' ? { count: this.canotLoanReason } : {}
        // isShow 从poor-credit界面点击下次再说控制 不再跳转
        if (status !== null && !this.$route.query.isShow) {
          this.$router.replace({
            path: '/withdraw/poor-credit',
            query: {
              status,
              ...count
            }
          })
        } else {
          await this.getLoanParameter()
          this.getLoanDetentionType()
        }
      }
    } catch (exp) {
      this.$bus.$emit('error')
    }

    this.$statistics('WITH')

    this.showBackHomeDrag = true
    // 初始化埋点事件
    this.initDataEvent()
  },
  destroyed () {
    this.setNeedsShowReconfirmDialog(null)
    this.$storage.remove('withSvipDialog')
    this.destoryDataEvent()
  },

  beforeRouteLeave (to, from, next) {
    /**
     * hack代码：解决已选择期数再查看还款计划，
     * 银行卡等页面后回来期数被默认选择最大期数
     * 的方法重制的bug，QAQ，暂时没想到好办法
     * */
    if (['withdrawPreview', 'smallFlowerBase'].includes(to.name)) {
      this.setWithdrawForm(this.form)
      this.$storage.set('withdrawForm', this.form)
    } else {
      this.setWithdrawForm({
        applyAmt: '',
        applyTerm: '',
        bankCardNo: '',
        purpose: ''
      })
      this.$storage.set('withdrawForm', {})
    }
    next()
  },
  methods: {
    ...mapActions('withdraw', [
      'getLoanParameterX',
      'getLoanTrialX',
      'getFundRouteX',
      'canLoanX',
      'amtProductX',
      'getMaxLimit',
      'judgeMissingX',
      'loanAmountPage',
      'svipGuidePopup',
      'getLoanDetentionPopType',
      'subscriptX'
    ]),
    ...mapActions('vip', [
      'memberInfo',
      'orderList'
    ]),
    ...mapActions('user', ['getUserInfoX', 'getBizTag', 'showStatusX', 'getLimitX']),

    ...mapMutations('withdraw', ['setWithdrawForm']),

    ...mapActions(['fetchDictionaryX', 'getCaseListX']),
    async getSubscript () {
      const { success, data } = await this.subscriptX()
      if (success) {
        this.subscriptData = data
      }
    },
    async checkIsPasscard () {
      const [bizTagRes, showStatusRes] = await Promise.all([
        this.getBizTag(),
        this.showStatusX({
          rightsType: 'PASS'
        })
      ])
      if (bizTagRes.success && showStatusRes.success) {
        const isPasscard = bizTagRes.data.passCardTag === 'HAVE_EFFECTIVE_LIMIT' && showStatusRes.data
        if (isPasscard) {
          const query = this.$route.query.couponSerialNos ? { couponSerialNos: this.$route.query.couponSerialNos } : {}
          this.$router.replace({
            path: '/withdraw/passcard',
            query: query
          })
        }
        return isPasscard
      }
      return false
    },
    // 判断跳转状态
    // 跳转到其它界面传参 unsatisfied:贷后还款表现不满足放款 time当前时间系统暂不支持提现 failed身份信息验证失败，暂不支持提现 expired身份证信息已到期，需重新上传 aboutToExpire您的身份证信息30天内即将过期
    judge (canLoanCode) {
      let status = null
      switch (canLoanCode) {
        case 'F_000100':
          status = 'unsatisfied'
          break
        case 'F_000054':
          status = 'time'
          break
        case 'F_000051':
          status = 'failed'
          break
        case 'F_000023':
          status = 'expired'
          break
        case 'F_000052':
          status = 'aboutToExpire'
          break
        case 'F_000042':
          status = 'tooMuchLoan'
          break
        case 'F_000032':
          status = 'amountTooLow'
          break
        default:
          status = null
      }
      return status
    },

    setNeedsShowReconfirmDialog (value) {
      if (!value) {
        removeKey('needShowReconfirmDialog')
      } else {
        setKey('needShowReconfirmDialog', value)
      }
    },
    // 是否有已存在订单
    async judgeOrder () {
      this.svipDialog = false
      const res = await this.orderList({ Status: '' })
      if (res.success) {
        let payStatusInfo = res.data || {}
        if (
          payStatusInfo &&
          payStatusInfo.payStatus &&
          payStatusInfo.payStatus === 'WAIT_PAY'
        ) {
          this.payStatusInfo = payStatusInfo || {}
          this.payDialog = true
        } else {
          this.jumpMiddle()
        }
      }
    },
    // 跳转到收银台
    jumpMiddle (modeOfPayment, payStatusInfo) {
      let discountPriceValue = ''
      let mode = {}
      let goods = ''
      if (modeOfPayment === 'continue') {
        const { originalAmount, couponUseDetail, reducedAmount, goodsCd } = this.payStatusInfo || payStatusInfo || {}
        discountPriceValue = originalAmount
        goods = goodsCd
        mode = { couponUseDetail: JSON.stringify(couponUseDetail), modeType: 'continue', reducedAmount }
      }
      this.dialog = false
      let host = encodeURIComponent(window.location.href)
      let gid = localStorage.getItem('gid')
      let token = getKey('userInfo', 'token') || ''
      let device = this.getDevice()
      const { discountPrice, memberGoodsGroupCd, memberGoodsCd } = this.svipData || {}
      const origin = process.env.VUE_APP_PAYURL
      const channel = getKey('channel') || ''
      const path = '/pay'
      const query = {
        host,
        gid,
        token,
        channel,
        device,
        modeType: modeOfPayment,
        discountPrice: discountPriceValue || discountPrice,
        memberType: goods || memberGoodsCd,
        memberGoodsGroupCd: this.payStatusInfo.memberGoodsGroupCd || memberGoodsGroupCd || 'SVIP',
        status: this.status,
        ...mode
      }
      window.location.href = `${origin}${path}?${qs.stringify(query)}`
    },
    // 获取banner数据
    async  loanAmountPageX () {
      const response = await this.loanAmountPage()
      if (response.success) {
        const { loanLimitTips } = response.data || {}
        this.svipLimitTips = loanLimitTips
      }
    },
    jumpVip () {
      const { couponSerialNos, couponType } = this
      let gid = localStorage.getItem('gid')
      let token = getKey('userInfo', 'token') || ''
      const channel = getKey('channel') || ''
      let data = `gid=${gid}&token=${token}&position=2&purchaseSVIP=fuli&channel=${channel}`
      couponSerialNos && (data += `&couponSerialNos=${couponSerialNos}`)
      couponType && (data += `&couponType=${couponType}`)
      window.location.replace(`${process.env.VUE_APP_PAYURL}/vip/ssvip?${data}`)
    },
    // 判断是否有svip资格
    async memberInfoX () {
      const res = await this.memberInfo({ svipProcessNode: 'LOAN_GUIDE_PAGE' })
      let { meetSVIP } = res.data || {}
      if (res.success && meetSVIP) {
        return true
      } else {
        return false
      }
    },
    // 获取借款要素
    async getLoanParameter () {
      const response = await this.getLoanParameterX({
        loanPlatform: 'TMD',
        virtualLimit: 'Y'
      })
      if (response.success && response.data) {
        this.bizAdjustAmount = response.data.bizAdjustAmount
        this.limitMaxCanLoanAmount = response.data.limitMaxCanLoanAmount
        // 初始化range区间及间隔
        if (this.isExternalChannel) {
          // 初始化range区间及间隔
          this.productRemaindLimit = response.data.productMaxLimit
          this.productMaxLimit = Math.floor(response.data.productMaxLimit / 100) * 100
          this.productMinLimit = response.data.productMinLimit
          this.lendingAmountStep = response.data.lendingAmountStep
            ? response.data.lendingAmountStep
            : 500
          // 额度默认取最大
          this.form.applyAmt = this.form.applyAmt || this.productMaxLimit
          // 产品列表
          this.productSubList = response.data.productSubList
        } else {
          this.productRemaindLimit = response.data.creditLimit
          // this.productMaxLimit = Math.floor(response.data.productMaxLimit / 100) * 100
          this.productMinLimit = response.data.productMinLimit
          this.lendingAmountStep = response.data.lendingAmountStep
            ? response.data.lendingAmountStep
            : 500
          this.productMaxLimit = response.data.userMaxLimit
          // 额度默认取后端返回
          this.form.applyAmt = this.form.applyAmt || response.data.productDefaultAmt
          // 产品列表
          this.productSubList = response.data.productSubList
        }
        // 处理caseList
        this.popupList = this.caseList.filter(item => item.showType === 'POPUP' && item.showAction === 'EXIT' && item.step === 'LOAN').sort((a, b) => b.sort - a.sort)
        // 默认借款用途
        const allLoanPurposeKeys = this.dictionary.loanPurpose.map(item => item.key)
        if (this.dictionary.defaultLoanPurpose && allLoanPurposeKeys.includes(this.dictionary.defaultLoanPurpose)) {
          this.form.purpose = this.dictionary.defaultLoanPurpose
        }
      } else {
        throw new Error('借款要素获取失败')
      }
      return response.data
    },

    // 当前是否可借款
    async canLoan () {
      const params = {
        loanPlatform: 'TMD',
        fundCode: this.fundCode,
        applyAmount: this.form.applyAmt || '',
        totalTermNo: this.form.applyTerm || ''
      }
      if (this.isFromPassCard) {
        params.passCardProcess = 'Y'
      }
      const response = await this.canLoanX(params)
      if (response.success) {
        const { code, canLoanApply, loanNum, message, canLoanApplyMessage } = response.data
        this.canLoanCode = code
        this.canLoanApply = canLoanApply
        this.canotLoanReason = code === 'F_000042' ? loanNum : message
        this.canLoanApplyMessage = canLoanApplyMessage
      }
    },

    // 通过金额查询子产品
    async getAmtProduct (applyAmount) {
      this.form.applyTerm = null
      const response = await this.amtProductX({
        loanPlatform: 'TMD',
        applyAmount: applyAmount
      })
      if (response.success) {
        let terms = response.data
        this.amtProductList = terms
        if (terms && terms.length > 0) {
          this.form.applyTerm = terms[terms.length - 1]
        }
      } else {
        this.amtProductList = []
      }
    },

    // 键盘返回值
    async getKeyboardInput (value) {
      if (value) {
        if (value === 0) {
          this.closeKeyboard()
        } else if (value > 0 && value < this.productMinLimit) {
          this.form.applyAmt = this.productMinLimit
          this.$message(
            `您当前最小提现金额为${this.productMinLimit}元`
          )
        } else if (
          value >= this.productMinLimit &&
          value <= this.productMaxLimit
        ) {
          if (value % this.lendingAmountStep === 0) {
            this.form.applyAmt = value
          } else {
            this.form.applyAmt =
              Math.ceil(value / this.lendingAmountStep) *
              this.lendingAmountStep
            this.$message(
              `每笔提现金额必须为${this.lendingAmountStep}的整数倍`
            )
          }
        } else if (value > this.productMaxLimit) {
          this.form.applyAmt = this.productMaxLimit
          this.$message(
            `您当前最大提现金额为${this.productMaxLimit}元`
          )
        }
        if (this.productMaxLimit > value) {
          let { success, data } = await this.getMaxLimit({ 'loanPlatform': 'TMD' }) // 最大提现金额判断
          if (success && data) {
            this.tipsVisible = true
          }
        }
      }
      this.closeKeyboard()
      // 最大提现金额判断
    },
    // 关闭键盘
    closeKeyboard () {
      this.stepCount = 0
      this.keyboardVisible = false
    },

    // 点击步长
    stepHandler () {
      this.stepCount++
    },

    // 打开键盘
    openKeyboard () {
      if (['LOAN_UP_AMT', 'LOAN_COUPON_DISCOUNT', 'LOAN_BIZ_UP_AMT'].includes(this.reconfirmDialogData.loanPopType)) {
        // 点击了金额,如果接口返回对应数据，则需要弹出二次确认弹窗
        this.setNeedsShowReconfirmDialog(true)
      }
      this.$refs.keyboard.init(this.startMoney)
      this.keyboardVisible = true
    },

    beforeSelectTerm () {
      if (this.termList.length === 0) {
        // this.$message('当前没有可匹配的期数')
        return Promise.resolve(false)
      }
      return Promise.resolve(true)
    },

    async getFundRoute () {
      const params = {
        routeType: 'LOAN',
        loanPlatform: 'TMD',
        applyAmount: this.form.applyAmt,
        totatlTermNo: this.form.applyTerm,
        productCode: 'TMDP'
      }
      const response = await this.getFundRouteX(params)
      if (response.code === '100002') {
        this.$router.push({ path: '/withdraw/svip/middle', query: { svipSource: 1, purchaseSVIP: 'middle' } })
        return
      }
      if (response.success) {
        if (response.data.length === 0) {
          this.$message('今日额度已抢完，明天再来吧')
        } else {
          this.$storage.set('fundRoute', response.data[0])
          this.fundCode = response.data[0].fundCode
        }
      } else {
        this.$storage.remove('fundRoute')
        this.$message(response.msg)
      }
    },
    // 下一步，预览提现
    async next () {
      // 点击下一步后，不需要弹出二次确认弹窗
      this.setNeedsShowReconfirmDialog(false)
      let data = ''
      if (!getKey('withSvipDialog')) {
        const res = await this.svipGuidePopup()
        data = res.data
      }
      if (data) {
        this.svipData = data || {}
        this.svipDialog = true
        setKey('withSvipDialog', true)
      } else {
        const bizTagRes = await this.getBizTag()
        if (bizTagRes.success && bizTagRes.data.passCardTag === 'HAVE_QUALIFICATION' && this.creditStatus === 'LOAN_REFUSED') {
          this.passCardBuyGuideActionSheetVisible = true
          this.$sensors.track('PopupDisplay', { msg_name: 'PASS' })
          return
        }
        await this.getFundRoute()
        if (!this.fundCode) return
        const response = await this.getLoanTrialX({
          loanTerm: this.form.applyTerm,
          withdrawAmt: this.form.applyAmt,
          loanPlatform: 'TMD',
          fundCode: this.fundCode,
          repayMethod: 'AI',
          productCd: 'TMDP'
        })
        if (response.success) {
          this.$storage.set('repayTrail', response.data)
          const res = await this.judgeMissingX()
          if (res.success && res.data.missing) {
            let value = ''
            if (!['API-XHQB', 'API-rosewallet'].includes(getKey('channel'))) {
              value = 'F'
            } else {
              value = 'T'
            }
            this.$router.push(`/authentication/smallFlowerBase?notify=${value}&fundCode=${this.fundCode}`)
          } else {
            const { pricingPopup } = response.data || {}
            if (pricingPopup) {
              this.showPricingPopup = true
            } else {
              removeKey('withdrawButtonHasBeenClicked')
              const couponSerialNos = this.couponSerialNos ? { couponSerialNos: this.couponSerialNos, couponType: this.couponType } : {}
              this.$router.push({ path: '/withdraw/preview', query: { fundCode: this.fundCode, ...couponSerialNos } })
            }
          }
        }
      }
    },
    // 跳转预览提现界面
    jumpPreview () {
      removeKey('withdrawButtonHasBeenClicked')
      const couponSerialNos = this.couponSerialNos ? { couponSerialNos: this.couponSerialNos } : {}
      this.$router.push({ path: '/withdraw/preview', query: { fundCode: this.fundCode, ...couponSerialNos } })
    },
    // 最大提现
    maxWithdraw () {
      this.form.applyAmt = this.maxAmt
      this.$message(`已修改提现金额为${this.form.applyAmt}`)
      if (['LOAN_UP_AMT', 'LOAN_COUPON_DISCOUNT', 'LOAN_BIZ_UP_AMT'].includes(this.reconfirmDialogData.loanPopType)) {
        // 点击了金额,如果接口返回对应数据，则需要弹出二次确认弹窗
        this.setNeedsShowReconfirmDialog(true)
      }
    },

    initDataEvent () {
      window.addEventListener('deviceorientation', this.orientationEvent)
    },

    destoryDataEvent () {
      window.removeEventListener(
        'deviceorientation',
        this.orientationEvent
      )
    },

    orientationEvent () {
      let now = Date.now()
      if (now - throttleLastTimer > throttleGutter) {
        this.deviceorientationEventOccurCount++
        throttleLastTimer = now
      }
    },
    confirm () {
      this.form.applyAmt = this.productMaxLimit
      this.tipsVisible = false
    },
    cancel () {
      this.tipsVisible = false
    },
    async getLoanDetentionType () {
      const { success, data } = await this.getLoanDetentionPopType({
        reqType: 'LOAN'
      })
      if (success && data) {
        this.reconfirmDialogData = data
        this.needShowOldGuestDetentionPop = data.loanPopType === 'LOAN50'
      } else {
        this.needShowOldGuestDetentionPop = false
      }
    },
    // 用户挽留政策
    detention () {
      if (['API-rosewallet'].includes(getKey('channel'))) {
        window.history.go(-1)
        return 
      }
      if (this.canLoanApply) {
        this.detentionStep()
      } else {
        window.history.go(-1)
      }
    },
    // 开始判断
    detentionStep () {
      if (this.popupList.length > 0) {
        this.currentActivity = this.popupList.pop()
        if (this.currentActivity.activeType !== 'PAY_IF_REFUSE_NEW') {
          this.activityTempleVisible = true
        } else {
          this.activityVisible = true
        }
      } else {
        this.showDetentionPop()
      }
    },
    // 修改提现金额
    detensionForChangeAmount () {
      this.continueApply()
    },
    showDetentionPop () {
      if (getKey('needShowReconfirmDialog') === true) {
        this.reconfirmDialogVisible = true
      } else if (this.needShowOldGuestDetentionPop) {
        this.oldGuestDetentionVisible = true
      } else {
        this.detentionVisible = true
      }
    },
    // 继续激活额度
    continueApply () {
      this.detentionVisible = false
    },
    // 放弃激活额度
    giveUp (index) {
      this.detentionVisible = false
      this.$nextTick(() => {
        this.backHome()
      })
    },
    // 活动点击继续完成
    activityContinue () {
      if (this.currentActivity.activeType !== 'PAY_IF_REFUSE_NEW') {
        this.activityTempleVisible = false
      } else {
        this.activityVisible = false
      }
    },

    // 活动点击放弃
    activityGiveUp () {
      if (this.currentActivity.activeType !== 'PERSON_REPEAT_LOAN') {
        if (this.currentActivity.activeType !== 'PAY_IF_REFUSE_NEW') {
          this.activityTempleVisible = false
        } else {
          this.activityVisible = false
        }
        this.detentionStep()
      } else {
        this.giveUp(2)
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.page.withdraw-index {
    height: 100%;
    position: relative;
    background-color: #fafafa;
    box-sizing: border-box;
    .card-panel {
        background-color: #fff;
        margin-top: 20px;
    }

    /*金额选择*/
    .withdraw-money {
        padding: 0 30px;
        padding-bottom: 20px;

        .title {
            font-size: 30px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: #333;
            padding-top:40px;
            padding-bottom: 10px;
        }
        .temporary-limit {
          margin-bottom: -30px;
        }

        .money-operate {
            height: 88px;
            line-height: 88px;
            display: flex;
            flex-direction: row;
            align-items: center;
            border-bottom: 1px solid #eee;

            .money {
                font-size: 72px;
                font-family: DIN-Medium;
                font-weight: 400;
                float: left;
                flex: 1;
            }

            .max-withdraw {
                font-size: 28px;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                height: 60px;
                line-height: 60px;
                width: 190px;
                box-sizing: border-box;
                text-align: center;
                border: 1px solid #ff3446;
                color: #ff3446;
                border-radius: 40px;
            }
        }

        .money-range {
            height: 88px;
            line-height: 88px;
            font-size: 30px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: #999;

            .min-money {
                float: left;
            }

            .max-money {
                float: right;

                em {
                    font-style: normal;
                }
            }
        }
    }
    .ssvip-banner{
        width: 690px;
        height: 110px;
        background-size: cover;
        border-radius: 14px;
        padding:27px 0 0 127px;
        margin:20px auto 20px;
        .s-title{
            font-size: 28px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #763E12;
        }
        .s-content{
            font-size: 22px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #763E12;
        }
    }
    .tips {
        padding: 27px 40px;
        background: rgba(255, 249, 241, 1);
        font-size: 24px;
        color: rgba(255, 136, 100, 1);
        line-height: 33px;
    }
    .form {
        padding: 0 30px;

        .form-item {
            height: 110px;
            line-height: 110px;
            margin-top: 0;

            .nd-choose {
                label {
                    font-size: 30px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                }

                input {
                    font-size: 30px;
                }

                textarea {
                    font-size: 30px;
                }
            }
        }
    }
    .svip-banner{
        width: 710px;
        background: #FFF0DD;
        border-radius: 20px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #945612;
        line-height: 33px;
        padding:22px 28px 0 16px;
        display: flex;
        margin:30px auto 0;
        .red{
            color:#FF4633
        }
        >img{
            width:100px;
            height:88px;
        }
        .svip-banner-content{
            padding-left:5px;
        }
    }
    > .bottom {
        width: 750px;
        height: 230px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.04);
        position: fixed;
        bottom: 0;
        @keyframes scale {
          to {transform: scale(1.1);}
        }
        .animate-tag {
          font-size: 24px;
          color: #fff;
          line-height: 28px;
          height: 40px;
          background: rgba(0,0,0,0.8);
          border-radius: 20px 20px 20px 0px;
          line-height: 40px;
          padding: 0 20px;
          position: absolute;
          right: 30px;
          top:10px;
          animation: scale .5s infinite alternate;
          span {
            color: #FFF56A;
          }
        }
        .read-protocol {
            width: 100%;
            text-align: center;
            margin-top: 25px;
            span {
                font-family: 'PingFangSC-Regular';
                font-weight: 400;
                color: #666;
                font-size: 24px;
                line-height: 33px;
            }
        }
        .confirm {
            width: 650px;
            height: 94px;
            border-radius: 47px;
            margin: 30px auto 0;
        }
    }
    .tips-content {
        padding: 20px 50px 70px;
        .header {
            font-size: 42px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);
            line-height: 59px;
        }
        .body {
            margin-top: 26px;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 40px;
            .highlight {
                color: #ff3446;
            }
        }
        .footer {
            display: block;
            width: 460px;
            height: 80px;
            line-height: 80px;
            margin: 90px auto 0;
        }
        .cancel {
            margin-top: 40px;
            font-size: 28px;
            color: rgba(142, 178, 216, 1);
            line-height: 40px;
            text-decoration: underline;
            text-align: center;
        }
    }
    .detention-dialog {
        .detention-title {
            margin: 0 58px;
            text-align: center;
            font-size: 36px;
            line-height: 50px;
            font-family: PingFangSC-Medium,PingFang SC;
            font-weight: 500;
            padding-bottom: 34px;
            border-bottom: 1px solid #EEEEEE;
            span {
                font-size:36px;
                font-family:PingFangSC-Medium,PingFang SC;
                font-weight:500;
                color:rgba(255,70,51,1);
                line-height:50px;
            }
        }

        .giveup {
          li {
            height: 110px;
            line-height: 110px;
            text-align: center;
            font-size: 30px;
            font-family: PingFangSC-Regular,PingFang SC;
            font-weight: 400;
            color: @fc3;
            border-bottom: 1px solid #EEEEEE;
          }
        }

        .continue {
          border: 0px solid transparent;
          height: 160px;
          line-height: 160px;
          text-align: center;
          font-size: 36px;
          font-family: PingFangSC-Medium,PingFang SC;
          font-weight: 500;
          color: @theme;
          width: 100%;
          outline: none;
          background-color: #FFFFFF;
        }
    }

    .activity-dialog {
        .activity-content {
            padding: 0 60px;
            padding-top: 42px;
            padding-bottom: 42px;

            .slogan {
                height: 42px;

                img {
                    height: 100%;
                    width: unset;
                }
            }

            .text {
                font-size: 32px;
                font-family: PingFangSC-Regular,PingFang SC;
                color: @fc1;
                font-weight: 400;
                margin-top: 43px;
            }

            p {
                font-size: 32px;
                font-family: PingFangSC-Regular,PingFang SC;
                color: @fc1;
                font-weight: 400;

                em {
                    font-style: normal;
                    color: @theme;
                }
            }

            .description {
                width: 500px;
                height: 130px;
                background-color: #FFF0F0;
                padding: 29px 0;
                border-radius: 16px;
                margin-top: 55px;
                padding-left: 141px;
                position: relative;

                .desc-image {
                    height: 160px;
                    width: 116px;
                    background-image: url(../authentication/images/img_ren@2x.png);
                    position: absolute;
                    left: 30px;
                    bottom: 0px;
                    background-size: cover;
                }

                p {
                    font-size: 24px;
                    font-family: PingFangSC-Regular,PingFang SC;
                    font-weight: 400;
                    color: @fc2;
                    line-height: 1.6em;
                }
            }

            .continue-btn {
                width: 440px;
                margin: 0 auto;
                height: 80px;
                line-height: 80px;
                font-size: 36px;
                font-weight: 600;
                margin-top: 70px;
            }

            .giveup-btn {
                height: 40px;
                font-size: 28px;
                font-family: PingFangSC-Regular,PingFang SC;
                font-weight: 400;
                line-height: 40px;
                color: @fc3;
                text-decoration: underline;
                text-align: center;
                margin-top: 22px;
            }
        }

        .activity-template-content {
            width: 620px;
            height: 750px;
            background-size: contain;
            position: relative;

            .button-group {
                position: absolute;
                bottom: 48px;
                left: 50%;
                transform: translateX(-50%);

                .continue-btn {
                    width: 440px;
                    margin: 0 auto;
                    height: 80px;
                    line-height: 80px;
                    font-size: 36px;
                    font-weight: 600;
                    margin-top: 70px;
                }

                .giveup-btn {
                    height: 40px;
                    font-size: 28px;
                    font-family: PingFangSC-Regular,PingFang SC;
                    font-weight: 400;
                    line-height: 40px;
                    color: @fc3;
                    text-decoration: underline;
                    text-align: center;
                    margin-top: 22px;
                }
            }
        }
    }
    .pricingPopup-dialog{
        .pricingPopup{
            padding:0 0 40px 0;
            &-tip{
                margin-left:45px;
                height: 72px;
                font-size: 42px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #333333;
                line-height: 72px;
            }
            p{
                margin-left:45px;
                margin-top:34px;
                margin-right:35px;
                height: 80px;
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                line-height: 40px;
            }
            &-content{
                margin-top:20px;
            }
            &-button{
                margin:63px auto 0;
                width: 320px;
                height: 80px;
                line-height: 80px;
                background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
                border-radius: 40px;
            }
        }
    }
    .dialog{
        position: relative;
        .huang-guan{
          position: absolute;
          background: url('./image/img_0@2x.png');
          background-size:cover;
          width:420px;
          height:136px;
          top:-134px;
          left:106px;
        }
        &-top{
        width: 620px;
        height: 153px;
        background: linear-gradient(90deg, #FCD5AC 0%, #FEF6E4 100%);
        border-radius: 30px;
        padding-top:40px;
        margin-top:-40px;
        text-align: center;
        .success{
            font-size: 32px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #763E12;
        }
        .ji-huo{
            font-size: 24px;
            color: #763E12;
            padding-top:5px;
        }
        }
        &-center{
        display: flex;
        justify-content:space-between;
        width: 444px;
        margin:30px auto 0;
        &-left,&-right{
            display: flex;
            flex-direction: column;
            align-items:center;
            width: 207px;
            height: 167px;
            background: #FFF7E5;
            border-radius: 14px;
            padding-top:25px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
            >img{
            width:80px;
            height:80px;
            }
            >p{
            margin-top:15px;
            font-size: 24px;
            color: #763E12;
            }
        }
        }
        &-bottom{
        display: flex;
        justify-content:space-between;
        margin-bottom: 50px;
        .dialog-white,.dialog-red{
            width: 270px;
            line-height: 80px;
            height: 80px;
            margin:50px auto 0;
            border-radius: 47px;
            text-align: center;
            font-size: 30px;
        }
        .dialog-white{
                border: 1px solid #FF4633;
                color: #FF4633;
                background:white;
            }
            .dialog-red{
                background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
                color: #FFFFFF;
            }
        }
  }
}
</style>
